












import { defineComponent } from "@vue/composition-api";
import { Location } from "vue-router";
import providers from "@/lib/api";
import emitter from "@/lib/emitter";
import { $t } from "@/lib/i18nHelpers";
import { EVENTS } from "@/const";
import BaseButton from "@/components/BaseButton";
import BasePage from "@/components/BasePage";
import InputPassword from "@/components/InputPassword";
import PageTitle from "@/components/PageTitle";

export default defineComponent({
  name: "PageForgotPasswordSet",
  components: { InputPassword, BasePage, BaseButton, PageTitle },
  props: {
    email: { type: String, default: "" },
    token: { type: String, default: "" },
    changePassword: { type: Boolean, default: false },
  },
  data() {
    return {
      loading: false,
      password: "",
    };
  },
  computed: {
    nextRoute(): Location {
      if (!this.changePassword) {
        return { name: "login" };
      }
      return {
        name: "more",
        query: { section: "account" },
      };
    },
  },
  methods: {
    async submit() {
      if (!this.password) {
        alert($t("Password field is empty"));
        return;
      }
      try {
        this.loading = true;
        await providers.PasswordResetProvider.change({ data: { password: this.password, token: this.token } });
        this.$router.push(this.nextRoute);
        if (this.changePassword) {
          emitter.emit(EVENTS.NOTIFICATION_SHOW, { text: $t("Password has been changed") });
        }
      } finally {
        this.loading = false;
      }
    },
  },
});
